import { useMemo } from 'react';
import { getDictionary } from '../i18n/dictionary';
import type { PreviewDictionary } from '../i18n/types';
import { usePreview } from './PreviewContext';

/**
 * Returns the translation dictionary for the active preview language.
 *
 * Components consume strings as plain object access:
 *
 *     const t = useT();
 *     <span>{t.bottomTabBar.home}</span>
 *
 * This deliberately replaces the
 * `language === 'fr' ? Text.ACVT.x.fr : Text.ACVT.x.en` ternaries that
 * are sprinkled through the existing `Acvt*` components. New code added
 * during the CTCAN-117 revamp should always reach for `useT` rather
 * than reading from `~utils/text`.
 */
export const useT = (): PreviewDictionary => {
    const { language } = usePreview();
    return useMemo(() => getDictionary(language), [language]);
};
